import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import UserTitle from '../components/user.title';
import UserSideMenu from '../components/user.side-menu';
import Pagination from 'rc-pagination';
import _ from 'lodash';
import ItemsVoucherOrder from '../components/user.voucher-order';

export class voucherMain extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            voucher: props.voucher,
            currentPage: 1,
            rowsPerPage: 5,
            totalItems: props.voucher.length
        }
    }

    componentDidMount() {
        if (this.props.voucher) {
            const { voucher, voucherOrderFilter } = this.props;
            const newVoucherOrderData = this.voucherOrderDataFilter(voucher, voucherOrderFilter);
            this.setState({ voucher: newVoucherOrderData, totalItems: newVoucherOrderData.length });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevProps.voucherOrderFilter, this.props.voucherOrderFilter)) {
            const { voucher, voucherOrderFilter } = this.props;
            const newVoucherOrderData = this.voucherOrderDataFilter(voucher, voucherOrderFilter);
            this.setState({ voucher: newVoucherOrderData, totalItems: newVoucherOrderData.length });
        }
    }

    voucherOrderDataFilter = (data, filter) => {
        if (filter === 'ทั้งหมด') return data;
        return _.filter(data, o => o.status === filter);
    };

    handleCurrentPageChange = currentPage => {
        this.setState({ currentPage });
        window.scrollTo(0, 0);
    }

    handleChangeFilter = name => {
        const { UserVoucherOrderFilterChange } = this.props;
        this.setState({ currentPage: 1 });
        UserVoucherOrderFilterChange(name);
    }

    render() {
        const { rowsPerPage, currentPage, totalItems, voucher } = this.state;
        const { wording, voucherOrderFilter } = this.props;

        return (
            <div className='main-wrapper shop oh'>
                <UserTitle title={wording.usermenu.voucher.myVoucher} />
                <section className='section-wrap pt-70 pb-40 catalogue'>
                    <div className='container relative'>
                        <div className='row'>
                            <aside className='col-md-3 sidebar'>
                                <UserSideMenu />
                            </aside>
                            <div className='col-md-9 catalogue-col right mb-50 container-list-user'>
                                {voucher.length === 0 && (
                                    <div className='shop-catalogue grid-view'>
                                        <div className='row text-center'>
                                            <div className='col-md-10 col-md-offset-1'>
                                                <div className='icon-warpper'>
                                                    <img src='/assets/img/sf/not-found.png' alt='not-found.png' />
                                                </div>
                                                <h1 className='uppercase'>{wording.usermenu.voucher.empty}</h1>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {voucher.length > 0 && (
                                    <div className='shop-catalogue grid-view'>

                                        <div className='mb-20'>
                                            <ul className='nav nav-pills nav-justified list-filter-user'>
                                                <li
                                                    role='presentation'
                                                    className={voucherOrderFilter === 'ทั้งหมด' ? 'active' : null}>
                                                    <a
                                                        className='pointer'
                                                        onClick={() => this.handleChangeFilter('ทั้งหมด')}>
                                                        {wording.usermenu.purchase.all}
                                                    </a>
                                                </li>
                                                <li
                                                    role='presentation'
                                                    className={voucherOrderFilter === 'FAILED' ? 'active' : null}>
                                                    <a
                                                        className='pointer'
                                                        onClick={() => this.handleChangeFilter('FAILED')}>
                                                        {wording.usermenu.purchase.failed}
                                                    </a>
                                                </li>
                                                <li
                                                    role='presentation'
                                                    className={voucherOrderFilter === 'SUCCESS' ? 'active' : null}>
                                                    <a
                                                        className='pointer'
                                                        onClick={() => this.handleChangeFilter('SUCCESS')}>
                                                        {wording.usermenu.purchase.delivered}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className='row items-grid'>
                                            <ItemsVoucherOrder 
                                                voucher={voucher}
                                                currentPage={currentPage}
                                                rowsPerPage={rowsPerPage}
                                            />
                                        </div>
                                    </div>
                                )}
                                {totalItems > rowsPerPage && (
                                    <div className='mt-30' style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Pagination
                                            onChange={this.handleCurrentPageChange}
                                            current={currentPage}
                                            pageSize={rowsPerPage}
                                            total={totalItems}
                                            showTitle={false}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = ({ user, language }) => ({
    voucher: user.voucher.data,
    wording: language.wording,
    currentLanguage: language.currentLanguage,
    voucherOrderFilter: user.voucher.filter
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            UserVoucherOrderFilterChange: Actions.UserVoucherOrderFilterChange
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(voucherMain);